import { useContext } from "react"
import ConstantsContext from "../contexts/ConstantsContext"

const useConstants = () => {
  const context = useContext(ConstantsContext)

  if (!context) throw new Error("context must be use inside provider")

  return context
}

export default useConstants
